import { TextEditor } from 'ui-components'
import { useReadmeNodes } from '~map-preview/states/map'

function MapDescriptionEditor(props) {
  const nodes = useReadmeNodes()

  if (!nodes) return null

  return (
    <TextEditor
      {...props}
      readOnly
      initialValue={nodes}
    />
  )
}

export { MapDescriptionEditor }
